export function isWheelBattleGame(item) {
  return !!(item && item.type === 'game' && Number(item.gameMode) === 1)
}

export function goGameDetail(router, item) {
  if (!router || !item || !item.id) {
    return
  }
  if (isWheelBattleGame(item)) {
    router.push({ path: '/new-game-detail/' + item.id + '/wheel-battle' })
    return
  }
  router.push({ path: '/new-game-detail/' + item.id + '/home' })
}
